import admin from "./admin";
import buyer from "./buyer";
import user from "./user";

const menus = {
  admin,
  buyer,
  user,
};

export default menus;
